import { transform } from "typescript";

export const constants = {
  MIN_ZOOM : 1,
  MAX_ZOOM : 4,
  ZOOM_STEP : 0.0325,
  ROTATION_DEG : 90,
  SCROLL_SPEED : 0.1,
  LEAST_POSSIBLE_ZOOM: 0.25
} 

  
export const types = {
  PAN:"PAN",
  START_PAN : "START_PAN",
  START_SCROLL_PAN : "START_SCROLL_PAN",
  ZOOM : "ZOOM",
  BOUND_PAN : "BOUND_PAN",
  INVERT_COLOR : "INVERT_COLOR",
  ROTATE : "ROTATE",
  SCALE : "SCALE",
  LOAD : "LOAD",
  RESET_TO_ORIGINAL: "RESET_TO_ORIGINAL"

};

  export const startPan = (e:any) => ({
    type: types.START_PAN,
    pageX: e.pageX,
    pageY: e.pageY,
  });
 
  export const pan = (e : any,wrapperRef : any, containerRef:any) => ({
    type: types.PAN,
    pageX: e.clientX,
    pageY: e.clientY,
    wrapperRef: wrapperRef,
    containerRef:containerRef
  
  });
  export const boundPan = (e : any,containerRef : any , imageRef:any) => ({
    type: types.BOUND_PAN,
    pageX: e.clientX,
    pageY: e.clientY,
    containerRef : containerRef,
    imageRef : imageRef

  });

  export const invertColor = ( invertClr:number) => ({
    type: types.INVERT_COLOR,
   invertClr : invertClr

  });

  export const rotate = ( direction : number, degrees:number,transformOrigin:string,x: number , y : number) => ({
    type: types.ROTATE,
    direction : direction,
    degrees : degrees,
    transformOrigin:transformOrigin,
    x: x , 
    y: y

  });

  export const scale = ( factor:number, up : boolean , x: number , y : number, transformOrigin:string) => ({
    type: types.SCALE,
    factor : factor,
    up: up, 
     x: x , 
     y: y,
     transformOrigin:transformOrigin

  });

  export const resetToOriginal = ( direction : number, degrees:number) => ({
    type: types.RESET_TO_ORIGINAL,
    direction : direction,
    degrees : degrees,
  });
  
  export const imgLoad = ( width:number, height : number,transformOrigin:string ) => ({
    type: types.LOAD,
    width : width,
    height : height,
    transformOrigin:transformOrigin
  });
 

 

  export const zoom = (e : any, containerRef : any ,wrapperRef : any, imageRef : any) => ({
    type: types.ZOOM,
    pageX: e.clientX,
    pageY: e.clientY,
    deltaY : e.deltaY,
    wrapperRef: wrapperRef,
    imageRef : imageRef,
    containerRef : containerRef 
  });

 





  